<template>
    <v-dialog-old id="reviewsMoving" ref="dialog" @hidden="clearData()" :onCloseEsc="closeModal">
        <v-dialog-old @hidden="closeModal" :onCloseEsc="closeModal" ref="messageDialog" class="glue">
            <div style="width: 483px">
                <strong>{{ message }}</strong>
            </div>
            <footer><button @click="closeModal" class="green btn-norm" type="submit">OK</button></footer>
        </v-dialog-old>

        <ValidationObserver ref="validation">
            <fieldset>
                <legend>Перенос отзывов</legend>

                <div style="display: flex; flex-direction: column;">
                    <p>
                        <label>URL откуда</label>
                        <vee-input :input-class="{hasError: urlFrom && errors[0]}"
                                   v-tooltip="{
                                       content: urlFrom && errors[0] ? errors[0] : null,
                                       template: $errTemplate
                                   }"
                                   @blur="validateUrls"
                                   rules="required"
                                   v-model="urlFrom"/>
                    </p>

                    <p>
                        <label>URL куда</label>
                        <vee-input :input-class="{hasError: urlTo && errors[1]}"
                                   v-tooltip="{
                                       content: urlTo && errors[1] ? errors[1] : null,
                                       template: $errTemplate
                                   }"
                                   @blur="validateUrls"
                                   rules="required"
                                   v-model="urlTo"/>
                    </p>

                    <div>
                        <v-loading-component @click="moveComments($event)">
                            <template slot-scope="{ loadingClass }">
                                <button class="green">Перенести</button>
                            </template>
                        </v-loading-component>
                    </div>
                </div>
            </fieldset>

            <div>
                <template v-if="ratings.length">
                    <div v-if="ratings[0].reviewee_type === 'CLINIC'">
                        Найдена клиника: {{ ratings[0].reviewee.name }}
                        <br>
                        Адрес: {{ ratings[0].reviewee.address }}
                    </div>
                    <div v-else>
                        Найден врач: {{ ratings[0].reviewee.name }}
                    </div>
                </template>

                <table v-if="ratings.length" class="table">
                    <tr>
                        <th>
                            <input type="checkbox"
                                   :value="true"
                                   :class="{hasError: trySubmit}"
                                   v-tooltip="{
                                       content: trySubmit ? 'Не выбраны отзывы!' : null,
                                       template: $errTemplate
                                   }"
                                   @click.stop.prevent="selectAll"
                                   v-if="!selectedIds.length">
                            <input type="checkbox" :value="true" @click.stop.prevent="selectNone" v-if="selectedIds.length > 0 && selectedIds.length < ratings.length" indeterminated>
                            <input type="checkbox" :value="true" @click.stop.prevent="selectNone" v-if="selectedIds.length > 0 && selectedIds.length >= ratings.length" checked>
                        </th>
                        <th>Оставлен</th>
                        <th>Рейтинг</th>
                        <th>Отзыв</th>
                        <th>Автор</th>
                        <th>Проверено</th>
                        <th>Проверил</th>
                        <th>Источник</th>
                    </tr>

                    <template v-for="(item, index) in ratings">
                        <tr :key="index" :class="['hover', 'pointer']">
                            <td>
                                <input type="checkbox" v-model="selectedIds" :value="item.id" @click.stop>
                            </td>
                            <td class="text-nowrap">
                                {{ item.created_at | formatDate }}
                            </td>
                            <td class="text-nowrap">
                                <div v-tooltip="{content: getTooltipExt(item)}">
                                    <div v-html="ratingFaStars(item.rating * 5)"/>
                                </div>
                            </td>
                            <td>
                                <div class="commentTextElipsis">
                                    <template v-if="item.common_text">
                                        <i class="fat fa-comment nomark" v-tooltip.left="'Общее впечатление'"/>{{ item.common_text }}<br>
                                    </template>
                                </div>
                            </td>
                            <td>
                                {{ item.author_name }}
                            </td>
                            <td class="text-nowrap">
                                {{ item.moderated_at | formatDate }}
                            </td>
                            <td>
                                {{ item.moderator.fio === 'Автоматизированная система актуализации данных' ? 'АСАД' : item.moderator.fio }}
                            </td>
                            <td>
                                {{ item.source }}
                            </td>
                        </tr>
                    </template>
                </table>
            </div>
        </ValidationObserver>
    </v-dialog-old>
</template>

<script>
    import _ from "lodash";

    export default {
        props: {
            urlsFrontend: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                urlFrom: '',
                urlTo: '',
                ratings: [],
                selectedIds: [],
                message: null,
                trySubmit: false,
                errors: [null, null],
            }
        },

        created: function () {
            this.getDebouncedComments = _.debounce(this.getRatings, 500);
        },

        methods: {
            clearData () {
                this.urlFrom = '';
                this.urlTo = '';
                this.ratings = [];
                this.selectedIds = [];
                this.message = null;
                this.trySubmit = false;
                this.errors = [null, null];
            },

            closeModal () {
                this.clearData();
                this.$refs.dialog.hide();
            },

            validateUrls () {
                this.axios.post('reviews/validateUrls', {
                    from: this.urlFrom,
                    to: this.urlTo,
                }).then(response => {}, (error) => {
                    if (error.urlErrors !== undefined) {
                        this.errors = error.urlErrors;
                    }
                });
            },

            getRatings: function () {
                this.axios.get('reviews/getRatingsByUrl/' + encodeURI(this.urlFrom), {}).then(response => {
                    this.ratings = response.data.data;
                    if (!this.ratings.length) {
                        this.errors[0] = 'Нет отзывов';
                    } else {
                        this.errors[0] = null;
                    }
                },(error) => {
                    if (error.urlErrors !== undefined) {
                        this.errors = error.urlErrors;
                    }
                });
            },

            moveComments: function (btn) {
                this.trySubmit = true;
                this.$refs.validation.validate().then(success => {
                    if (!success || this.urlFrom === this.urlTo || !this.selectedIds.length) {
                        if (success && this.urlFrom === this.urlTo) {
                            this.errors[1] = 'Одинаковый URL';
                        }
                        const el = document.querySelector(".hasError:first-of-type");
                        el.scrollIntoView({behavior: "smooth"});
                        return;
                    }

                    this.errors = [null, null];
                    btn.startLoadingAnimation();
                    this.axios.post(
                        `reviews/move`,
                        {
                            from: this.urlFrom,
                            to: this.urlTo,
                            reviewIds: this.selectedIds,
                        }
                    ).then(response => {
                        btn.stopLoadingAnimation()
                        this.message = response.data.info;
                        this.$refs.messageDialog.show();
                    },(error) =>{
                        btn.stopLoadingAnimation()
                        if (error.info !== undefined) {
                            this.message = 'Ошибка: ' + error.info;
                            this.$refs.messageDialog.show();
                        } else if (error.urlErrors !== undefined) {
                            this.errors = error.urlErrors;
                        }
                    });
                });
            },

            show: function () {
                this.$refs.dialog.show();
            },

            selectAll: function () {
                this.selectedIds = [];
                this.ratings.forEach((rating) => {
                    this.selectedIds.push(rating.id);
                });
            },

            selectNone: function () {
                this.selectedIds = [];
            },

            getTooltipExt(row) {
                if (!row.rating_extended || row.rating_extended.filter((el) => el).length <= 1) {
                    return '';
                }
                if (row.reviewee_type === 'DOCTOR') {
                    return `<table>
                <tr><td colspan="2" align="center">` + (Math.round(row.rating * 5 * 10) / 10).toFixed(1) + `</td></tr>
                <tr><td>Тщательность:   </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[0] * 5) + `</td></tr>
                <tr><td>Эффективность:  </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[1] * 5) + `</td></tr>
                <tr><td>Отношение:      </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[2] * 5) + `</td></tr>
                <tr><td>Информирование: </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[3] * 5) + `</td></tr>
                <tr><td>Посоветуете:    </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[4] * 5) + `</td></tr>
            </table>`
                }
                return `<table>
                <tr><td colspan="2" align="center">` + (Math.round(row.rating * 5 * 10) / 10).toFixed(1) + `</td></tr>
                <tr><td>Месторасположение:    </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[0] * 5) + `</td></tr>
                <tr><td>Персонал:             </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[1] * 5) + `</td></tr>
                <tr><td>Цена/качество:        </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[2] * 5) + `</td></tr>
                <tr><td>Комфорт пребывания:   </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[3] * 5) + `</td></tr>
                <tr><td>Посоветуете:          </td><td>&nbsp;` + this.ratingFaStars(row.rating_extended[4] * 5) + `</td></tr>
            </table>`
            },

            ratingFaStars(rating) {
                let colorClass = '';
                if (rating === null) {
                    colorClass = 'grey';
                }
                let __ = '<i class="far fa-sm fa-star starsMargin ' + colorClass + '"></i> ';
                let X_ = '<i class="fas fa-sm fa-star-half-alt starsMargin ' + colorClass + '"></i> ';
                let XX = '<i class="fas fa-sm fa-star starsMargin ' + colorClass + '"></i> ';

                // @formatter:off
                if (rating === null) return __ + __ + __ + __ + __;
                else if (rating <= 0.25) return __ + __ + __ + __ + __;
                else if (rating <= 0.75) return X_ + __ + __ + __ + __;
                else if (rating <= 1.25) return XX + __ + __ + __ + __;
                else if (rating <= 1.75) return XX + X_ + __ + __ + __;
                else if (rating <= 2.25) return XX + XX + __ + __ + __;
                else if (rating <= 2.75) return XX + XX + X_ + __ + __;
                else if (rating <= 3.25) return XX + XX + XX + __ + __;
                else if (rating <= 3.75) return XX + XX + XX + X_ + __;
                else if (rating <= 4.25) return XX + XX + XX + XX + __;
                else if (rating <= 4.75) return XX + XX + XX + XX + X_;
                else return XX + XX + XX + XX + XX;
                // @formatter:on
            },
        },
        watch: {
            urlFrom: function (newValue) {
                this.selectedIds = [];
                if (newValue !== this.urlTo && this.errors[1] === 'Одинаковый URL'){
                    this.errors[1] = null;
                }
                if (newValue !== '') {
                    if (newValue === this.urlTo) {
                        this.errors[1] = 'Одинаковый URL';
                    }
                    this.getDebouncedComments();
                }
            },
            urlTo: function (newValue) {
                this.errors[1] = null;
                if (newValue !== '') {
                    if (newValue === this.urlFrom) {
                        this.errors[1] = 'Одинаковый URL';
                    }
                }
            }
        }
    }
</script>

<style>
    #reviewsMoving {
        width: 1500px;
    }

    #reviewsMoving table {
        font-size: 13px;
    }

    #reviewsMoving table input[type="checkbox"] {
        margin: auto;
    }

    #reviewsMoving table tr:first-child {
        background: #ebebeb;
    }

    #reviewsMoving table th, #reviewsMoving table td {
        border: 1px solid #ddd;
        padding: 1px;
    }

    #reviewsMoving input[type='checkbox'][checked] {
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z'/></svg>");
    }
</style>
